import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { NotificationsInboxService } from "@gtmhub/notifications/controllers/notifications-inbox";
import { CurrentUserService, getCurrentUserId } from "@gtmhub/users";
import { AnalyticsService } from "@webapp/analytics/services/analytics.service";
import { IScreen } from "@webapp/navigation/models/shared.models";

@Component({
  selector: "bottom-section-nav",
  templateUrl: "./bottom-section-nav.component.html",
  styleUrls: ["./bottom-section-nav.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomSectionNavComponent {
  @Input() public unreadNotificationsCount: number;
  @Input() public screens: IScreen[];
  @Input() public settingsScreen: IScreen;
  @Input("showMarketplace") public showMarketplace$: Observable<boolean>;
  @Input() public activeScreen: string;
  @Input() public unreadNotificationsCountAriaLabel: string;

  constructor(private analyticsService: AnalyticsService, private notificationsInboxService: NotificationsInboxService, private currentUserService: CurrentUserService) {}

  public openNotificationsModal(): void {
    this.notificationsInboxService.open({}, this.unreadNotificationsCount);
    this.analyticsService.track("Notification Modal Opened", { user_id: getCurrentUserId() });
  }

  public setMarketplaceCookie(): void {
    this.currentUserService.setMarketplaceRedirectCookie();
  }
}
